/* Khuttwa dark buy card: wraps viewers → sizes → stock → buy buttons of the main product into one card */
(function () {
  function wrap(root) {
    var scope = root || document;
    scope.querySelectorAll('.product-detail__buy-buttons').forEach(function (buy) {
      if (buy.closest('.kbc') || buy.closest('sticky-add-cart') || buy.closest('.quickview, [data-custom-class="quickview"]')) return;
      var parent = buy.parentElement;
      if (!parent) return;
      var wanted = function (el) { return el.matches('.live_view, .product-detail__variant-picker, stock-countdown, .product-detail__buy-buttons'); };
      var kids = Array.prototype.slice.call(parent.children);
      var idx = kids.map(function (el, i) { return wanted(el) ? i : -1; }).filter(function (i) { return i > -1; });
      if (!idx.length) return;
      /* take the longest run around the buy buttons where only wanted (or invisible) elements sit */
      var bi = kids.indexOf(buy), start = bi, end = bi;
      var passable = function (el) { return wanted(el) || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.offsetHeight === 0; };
      while (start > 0 && passable(kids[start - 1])) start--;
      while (end < kids.length - 1 && passable(kids[end + 1])) end++;
      while (start < bi && !wanted(kids[start])) start++;
      while (end > bi && !wanted(kids[end])) end--;
      var card = document.createElement('div');
      card.className = 'kbc';
      parent.insertBefore(card, kids[start]);
      for (var i = start; i <= end; i++) card.appendChild(kids[i]);
      if (window.kbcTicket === false) return;
      /* ticket: vendor + badge + title + reviews + price above the card, discount switch as a tear-off strip */
      var before = [], n = card.previousElementSibling;
      while (n) { before.unshift(n); n = n.previousElementSibling; }
      var head = before.filter(function (el) { return el.matches('.sale_badge, p.product-detail__meta-value, .product-detail__title, .review_sold, .product-detail__price'); });
      if (!head.some(function (el) { return el.matches('.product-detail__title, .product-detail__price'); })) return;
      var ticket = document.createElement('div');
      ticket.className = 'kbt';
      parent.insertBefore(ticket, card);
      head.forEach(function (el) { ticket.appendChild(el); });
      var sw = Array.prototype.filter.call(parent.children, function (el) { return el.id && el.id.indexOf('kcs-') === 0 && el.querySelector('.kcs'); })[0];
      if (sw) {
        var tear = document.createElement('div');
        tear.className = 'kbt-tear';
        parent.insertBefore(tear, card);
        tear.appendChild(sw);
      }
    });
  }
  function run() { wrap(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function (e) { wrap(e.target); });
})();
